module.exports = __webpack_public_path__ + "img/step3.66175eb8.png";